export class DocType {
  DocTypeCode;
  CDesc;
  EDesc;
  constructor() {
    this.DocTypeCode = "";
    this.CDesc = "";
    this.EDesc = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/DocType.js